import { apiHelper, getApiBaseUrl } from '../utils/apiHelper';

// const API_URL = `${process.env.REACT_APP_API_URL}/api/org/partner`;
const API_URL = `${getApiBaseUrl()}/api/org/partner`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchPartners = (payload) => apiHelper(API_URL, 'GET', payload);
export const createPartner = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchPartner = (partnerId) => apiHelper(`${API_URL}/${partnerId}`, 'GET');
export const modifyPartner = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deletePartnerApi = (partnerId) => apiHelper(`${API_URL}/${partnerId}`, 'DELETE');
export const changeStatus = (partnerId) => apiHelper(`${API_URL}/change-status/${partnerId}`, 'POST');

